module.exports = __webpack_public_path__ + "static/media/flash.2d7947b6.png";